
import { PropType } from "vue/types/v3-component-props";
import { computed, Ref } from "vue";
import {
  allAspects,
  Aspect,
  Point,
  WindRoseDimensions,
  WindRoseProps,
} from "./WindEuroseModels";
import { useWindEurose } from "@/components/eurose/useWindEurose";

export default {
  props: {
    aspects: {
      type: Array as PropType<Aspect[]>,
      default: () => [],
    },
  },
  setup(props: WindRoseProps) {
    const reactiveAspects = computed(() => props.aspects);

    const {
      dimensions,
      labelPositions,
      windrosePath,
      getAspectPath,
      isActiveAspect,
      viewBox,
    } = useWindEurose(reactiveAspects);

    return {
      dimensions: dimensions as Ref<WindRoseDimensions>,
      allAspects,
      labelPositions: labelPositions as Ref<Point[]>,
      windrosePath,
      getAspectPath,
      isActiveAspect,
      viewBox,
    };
  },
};
